import { SlotConfig } from './slotConfigs';
import { TabKeys } from '../components/InventoryView/InventoryViewConstants';
import {
  getGatewayData,
  getStarPackageData,
  getMThankyouData,
  getWPClass1Data,
  getILMClass1Data,
  getMContextualClass1CpmData,
  getDContextualClass1CpmData,
  getPPPClass1Data,
  getWD2TargetedClass1Data,
  getROSDSPUnguaranteedData,
} from '../services/service';

/**
 * Single source of truth for all slot configurations.
 * Used by both InventoryView (dashboard tabs) and inventoryExport (Excel export).
 */
export const SLOT_CONFIGS: SlotConfig[] = [
  {
    key: TabKeys.GATEWAY,
    sheetName: 'Gateway',
    fetchFn: getGatewayData,
  },
  {
    key: TabKeys.STAR_PACKAGE,
    sheetName: 'Star Package',
    fetchFn: getStarPackageData,
  },
  {
    key: TabKeys.MTHANKYOU,
    sheetName: 'MThankYou',
    fetchFn: getMThankyouData,
  },
  {
    key: TabKeys.WP_CLASS_1,
    sheetName: 'WP Class 1',
    fetchFn: getWPClass1Data,
  },
  {
    key: TabKeys.ILM_CLASS_1,
    sheetName: 'ILM Class 1',
    fetchFn: getILMClass1Data,
  },
  {
    key: TabKeys.MCONTEXTUAL_CLASS_1_CPM,
    sheetName: 'mContextual Class 1 CPM',
    fetchFn: getMContextualClass1CpmData,
  },
  {
    key: TabKeys.DCONTEXTUAL_CLASS_1_CPM,
    sheetName: 'dContextual Class 1 CPM',
    fetchFn: getDContextualClass1CpmData,
  },
  {
    key: TabKeys.PPP_CLASS_1,
    sheetName: 'PPP Class 1',
    fetchFn: getPPPClass1Data,
  },
  {
    key: TabKeys.WD2_TARGETED_CLASS_1,
    sheetName: 'WD2 Targeted Class 1',
    fetchFn: getWD2TargetedClass1Data,
  },
  {
    key: TabKeys.ROS_DSP_UNGUARANTEED,
    sheetName: 'ROS DSP Unguaranteed',
    fetchFn: getROSDSPUnguaranteedData,
  },
];
